
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParticipantVisitWindowV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantVisitWindowV2"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitWindowId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"studyName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"windowType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visits"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantVisitV2"},"directives":[]}]}}]}}],"loc":{"start":0,"end":218}};
    doc.loc.source = {"body":"#import \"./ParticipantVisitV2Fragment.graphql\"\n\nfragment ParticipantVisitWindowV2 on ParticipantVisitWindowV2 {\n\tvisitWindowId,\n\tstartDate,\n\tendDate,\n\tstudyName,\n\twindowType,\n\tvisits {\n    \t...ParticipantVisitV2\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./ParticipantVisitV2Fragment.graphql").definitions));


      module.exports = doc;
    
